import { Button, Col, DatePicker, TimePicker, Form, Input, Row, Select, Space, Switch, Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../WebEditUniversalNewExExEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import { SearchOutlined } from '@ant-design/icons';
import AntdNotification from '../../../utils/extend/AntdNotification';
import dayjs from 'dayjs';
import moment from 'moment';

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const Edit = (props: any) => {
    const [dbBackupsData, setDbBackupsData] = useState<any>();
    const [form] = Form.useForm(); //form 
    const { data } = props;
    if (data) {
        const { sendPageData } = data;
        if (sendPageData) {
            const { dbBackupsId } = sendPageData;
            form.setFieldValue('dbBackupsId', dbBackupsId)
        }
    }
    const [databaseData, setDatabaseData] = useState();
    const [sourceTableData, setSourceTableData] = useState();
    const [targetTableData, setTargetTableData] = useState();
    const [defaultService, setDefaultService] = useState<string>('');
    const [dataConflictResolutionData, setDataConflictResolutionData] = useState();
    const [specialDataDisabled, setSpecialDataDisabled] = useState<boolean>(true);

    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /**
     * 获取库中所有数据表
     * @param options 选项
     */
    const getTableNamesFromDB = (options: {
        databaseName: string,
        serviceUrl: string,
        type?: 'source' | 'target'
    }) => {
        const { databaseName, serviceUrl, type = 'source' } = options;
        fetchApi.GET(serviceUrl,
            {
                apiId: 'dbTables',
                apiExtend: 'getTableNamesFromDB',
                apiData: JSON.stringify({
                    databaseName
                })
            }).then(res => {
                if (res?.success === true) {
                    if (type === 'target') {
                        setTargetTableData(res.data);
                    } else {
                        setSourceTableData(res.data);
                    }
                }
            })
    };

    useEffect(() => {
        let urlService: any = '';
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            ref.current.row.then((res: any) => {
                if (res?.success === true) {
                    const { sourceDatabase, pointInTime
                        , targetDatabase, isDeleteSpecialDataFromTheSourceTable } = res.data;
                    getTableNamesFromDB({
                        serviceUrl: urlService,
                        databaseName: sourceDatabase
                    })
                    getTableNamesFromDB({
                        serviceUrl: urlService,
                        databaseName: targetDatabase,
                        type: 'target'
                    })
                    if (pointInTime) {
                        let pointInTimeData=dayjs().format("YYYY-MM-DD")+"T"+pointInTime
                       
                        form.setFieldValue("pointInTime", dayjs(pointInTimeData))

                    }
                    setSpecialDataDisabled(!isDeleteSpecialDataFromTheSourceTable);
                }
            })
        }
        fetchApi.GET(urlService, {
            apiId: 'dbBackups',
            apiExtend: 'showList'
        }).then(res => {
            if (res.success === true) {
                setDbBackupsData(res.data);
            }
        })
        fetchApi.GET(urlService,
            {
                apiId: 'generalData',
                apiVariable: 'database@dBBackupsDataConflictResolution',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { database, dBBackupsDataConflictResolution } = res.data;
                    setDatabaseData(database);
                    setDataConflictResolutionData(dBBackupsDataConflictResolution);
                }
            })
    }, []);

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'dbTables',
        // dateColumnName: ["pointInTime"]
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '数据表'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            // handleOk(e)
                        }
                    }}>
                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="数据库备份"
                                name="dbBackupsId">
                                <Select
                                    disabled={true}
                                    showSearch
                                    placeholder="数据库系统"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(dbBackupsData, {
                                        itemName: 'backupName'
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="源数据库"
                                name="sourceDatabase"
                                rules={[{ required: true, message: '请选择源数据库!' }]}>
                                <Select
                                    showSearch
                                    placeholder="源数据库"
                                    optionFilterProp="children"
                                    onChange={e => {
                                        getTableNamesFromDB({
                                            databaseName: e,
                                            serviceUrl: defaultService
                                        });
                                    }}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(databaseData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="源表"
                                name="sourceTableId"
                                rules={[{ required: true, message: '请选择源表!' }]}>
                                <Select
                                    showSearch
                                    placeholder="请选择源表"
                                    optionFilterProp="children"
                                    style={{ width: 275 }}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(sourceTableData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="目标数据库"
                                name="targetDatabase"
                                rules={[{ required: true, message: '请选择目标数据库!' }]}>
                                <Select
                                    showSearch
                                    placeholder="目标数据库"
                                    optionFilterProp="children"
                                    onChange={e => {
                                        getTableNamesFromDB({
                                            databaseName: e,
                                            serviceUrl: defaultService,
                                            type: 'target'
                                        });
                                    }}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(databaseData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="目标表"
                                name="targetTableId"
                                rules={[{ required: true, message: '请选择目标表!' }]}>
                                <Select
                                    showSearch
                                    placeholder="请选择目标表"
                                    optionFilterProp="children"
                                    style={{ width: 260 }}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(targetTableData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="冲突解决"
                                name="dataConflictResolutionId"
                                tooltip='数据备份时冲突的解决方案'>
                                <Select
                                    showSearch
                                    placeholder="数据冲突解决"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(dataConflictResolutionData, { includeNull: true })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="冲突主键"
                                tooltip='数据冲突解决主键，如不填，默认："id"'
                                name="primaryKey">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="N天前"
                                name="backupDaysBefore"
                                tooltip='备份N天前数据'
                                rules={[{ required: true, message: '请输入数字!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="时间点"
                                name="pointInTime"
                            >
                                <TimePicker
                                    format="HH:mm"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="关键字"
                                tooltip='查询备份N天前数据的关键字，如不填，默认："createdAt"'
                                name="backupDaysColumnName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={20}>
                            <Form.Item
                                label="父表依赖关系"
                                tooltip="所依赖的父表及外键关系，格式：表名@外键字段名，多个用逗号分隔。例如：父表名1@外键字段名1,父表名2@外键字段名2,..."
                                name="parentDependencies">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="排序"
                                name="sortBy"
                                tooltip='父表排前，子表排后'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="过滤语句"
                                tooltip="如有需要，可以附加过滤源表数据的SqlWhere语句，例如：a = 'a'"
                                name="sqlWhere">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="删除源表特别数据"
                                tooltip='根据备份条件及特别数据的SqlWhere删除源表特别数据，不可恢复'
                                name="isDeleteSpecialDataFromTheSourceTable"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    onChange={e => { setSpecialDataDisabled(!e); }}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={17}>
                            <Form.Item
                                label="特别数据的SqlWhere"
                                tooltip="删除源表特别数据的SqlWhere语句，例如：a = 'a'"
                                name="deleteSpecialDataSqlWhere">
                                <Input disabled={specialDataDisabled} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="删除源数据"
                                tooltip='删除源表数据，不可恢复'
                                name="isDeleteSourceTableData"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="检查结构"
                                name="isCheckStructureMatch"
                                tooltip='检查源表与目标表结构是否匹配'
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="禁用外键约束"
                                name="isDisableForeignKeyConstraints"
                                tooltip='禁用外键约束'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={true}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default Edit;